module.exports = __webpack_public_path__ + "img/eight.88d035d4.png";